import RpcResponse from "@/core/services/Rpc/RpcResponse";
import RpcService from "@/core/services/Rpc/RpcService";

class StickerColorsDAO {
	static async getList(): Promise<RpcResponse> {
		return await RpcService.makeRequest('stickers.getColorList');
	}
}

export default StickerColorsDAO;
